// extracted by mini-css-extract-plugin
export default {"container":"DeviceAdditionUploadIMEI_container__qUNQ5"};